/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchAgentOptimizationPathParams = NonNullable<operations['patchAgentOptimization']['parameters']['path']>;

export type PatchAgentOptimizationRequestBody = OperationRequestBodyContent<operations['patchAgentOptimization']>;

export interface Input extends PatchAgentOptimizationPathParams {
  apiVersion?: string;
  body: PatchAgentOptimizationRequestBody;
}

export async function patchAgentOptimization(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/agent-optimizations/{optimizationKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
